import { render, staticRenderFns } from "./infoMessage.vue?vue&type=template&id=92a70f9a&scoped=true&"
import script from "./infoMessage.vue?vue&type=script&lang=js&"
export * from "./infoMessage.vue?vue&type=script&lang=js&"
import style0 from "./infoMessage.vue?vue&type=style&index=0&id=92a70f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a70f9a",
  null
  
)

export default component.exports